// extracted by mini-css-extract-plugin
export default {"shalina-primaryBtn":"button_shalina-primaryBtn__zZV-L","downloadLoader":"button_downloadLoader__Nopvd"};